// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:1240px){#custom-stepper-header[data-v-2b4d74d1]{padding-right:50px;padding-left:50px}}@media screen and (max-width:800px){#custom-stepper[data-v-2b4d74d1]{margin:-20px}#custom-stepper-header[data-v-2b4d74d1]{padding-right:20px;padding-left:20px}}", ""]);
// Exports
module.exports = exports;
